import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {computed} from "vue";

interface Props {
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'PersonBankverbindungComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any) {


const props = __props

const _ibanSplit = computed(() => {
  const iban = props.details?.getValue(PersonDetailsId.Iban)
  return iban?.match(/.{1,4}/g)?.join(' ');
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "IBAN", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, { value: _ibanSplit.value }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "BIC", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).Bic)
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Bank", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).Bank)
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})